"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emailFooterText = exports.orgName = exports.projectName = exports.fromEmail = void 0;
exports.fromEmail = '"Prodeko Tapahtumat" <no-reply@prodeko.org>';
exports.projectName = "Ilmo";
exports.orgName = "Prodeko";
exports.emailFooterText = "© Tuotantotalouden Kilta Prodeko ry.";
//# sourceMappingURL=index.js.map